var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      attrs: {
        top: "",
        center: "",
        timeout: 10000,
        color: _vm.snackbarColor,
        "auto-height": ""
      },
      model: {
        value: _vm.showSnackbar,
        callback: function($$v) {
          _vm.showSnackbar = $$v
        },
        expression: "showSnackbar"
      }
    },
    [
      _vm.snackbarColor == "error-banner"
        ? _c("v-icon", { staticClass: "pr-1", attrs: { dark: "" } }, [
            _vm._v("warning")
          ])
        : _c("v-icon", { staticClass: "pr-1", attrs: { dark: "" } }, [
            _vm._v("done")
          ]),
      _vm._v(" "),
      _c("b", { domProps: { textContent: _vm._s(_vm.snackbarMessage) } }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "black--text snackbar-button",
          attrs: { color: _vm.snackbarColor },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_vm._v("Close")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }